export const IN = 'IN';
export const OUT = 'OUT';
